<template>
  <v-container no-gutters class="pa-0 info-block">
    <v-row no-gutters>
      <v-col cols="auto">
        <v-icon :small="small" left :class="[iconClass, 'info-icon']">{{ icon }}</v-icon>
      </v-col>
      <v-col :class="small ? 'caption' : ''" :style="small ? 'padding-top:2px;' : ''">
        <slot>
          {{ text }}
        </slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "InfoBlock",
  components: {},
  props: {
    text: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      default: "mdi-information-outline",
    },
    iconClass: {
      type: String,
      default: "",
    },
    small: {
      type: Boolean,
      default: false
    }
  },
};
</script>

<style scoped>
.info-block .info-icon {
  color: inherit;
}
</style>